/** URL of a file of public/ (`/assets/...`, `/fonts/...`) under the base path of the build (Vite `base`). */
export const asset = (path: string): string => `${import.meta.env.BASE_URL.replace(/\/$/, '')}${path}`;
